
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";

type KeepHeightContainerProps = {
    children: React.ReactNode;
};

const KeepHeightContainer: React.FC<KeepHeightContainerProps> = ({ children }) => {
    const ref = useRef<HTMLDivElement>(null);
    const inner = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>(0);
    const [windowWidth, setWindowWidth] = useState(0);

    useEffect(() => {
        const contentHeight = inner.current?.scrollHeight;
        setHeight(contentHeight || 58)
    }, [children, windowWidth])

    useEffect(() => {
        setWindowWidth(window.innerWidth);

        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
    <div ref={ref} style={{height}}>
        <div ref={inner}>
            {children}
        </div>
    </div>
    );
};

export default KeepHeightContainer;


